module.exports = "/assets/landing-25ab3fc205b062b9265680e8f751fc2b.png";